//我的账户
<template>
  <div id="pcib_account" v-loading="loading" element-loading-text="发送中...">
    <!-- <div class="nav">
            <router-link :to="{name: 'pcibHome'}">
                <i class="el-icon-arrow-left" title="返回">返回上一层</i>
            </router-link>
    </div>-->
    <div class="main">
      <ul class="details">
        <li v-for="(item, index) in list" :key="index">
          <ul>
            <li class="title">
              <span class="tips">{{item.title}}</span>
              <span class="btn" @click="isEdit(index)">
                <span v-if="item.readonly">编辑</span>
                <span v-else>取消</span>
              </span>
            </li>
            <li v-for="n in item.input" :key="n.id">
              <label :for="n.id">{{n.label}}</label>
              <input
                type="text"
                :id="n.id"
                v-model="n.value"
                :disabled="item.readonly || n.readonly"
                :readonly="item.readonly || n.readonly"
                v-if="!item.readonly && n.see"
              />
              <input
                type="password"
                :id="n.id"
                v-model="n.value"
                :disabled="item.readonly || n.readonly"
                :readonly="item.readonly || n.readonly"
                v-else
              />
            </li>
            <li>
              <p>
                {{item.tips}}，
                <span>我们会向当前邮箱发送确认链接，请登录当前邮箱确认以便更改生效</span>
              </p>
              <p>如果你不需要更改信息，请保持不变或留空</p>
            </li>
          </ul>
        </li>
        <button @click="saveData">发送邮件</button>
      </ul>
    </div>
  </div>
</template>

<script>
import { fetch, post } from "@/util/http";
export default {
  name: "PcibOrderAccount",
  beforeCreate() {
    let self = this;
    let token = sessionStorage.getItem("authToken");
    if (!token) {
      this.$router.push({
        name: "pcibOrderLogin"
      });
    }
  },
  created() {
    let self = this;
    fetch("user/userinfo/").then(res => {
      self.oldData = res;
      self.list[0].input[0].value = res.contact; //联系人
      self.list[0].input[1].value = res.phone; //电话
      self.list[0].input[2].value = res.address; //地址
      self.list[1].input[0].value = res.email; //当前邮箱
    });
  },
  data() {
    return {
      oldData: {}, //保存返回的用户数据，以便更改对比
      loading: false,
      list: [
        {
          title: "联系人管理",
          readonly: true,
          tips: "如果您需要更改您的联系人信息，请直接输入",
          input: [
            {
              label: "联系人",
              id: "user",
              value: "",
              see: true
            },
            {
              label: "电话",
              id: "tele",
              value: "",
              see: true
            },
            {
              label: "地址",
              id: "address",
              value: "",
              readonly: true,
              see: true
            }
          ]
        },
        {
          title: "邮箱管理",
          readonly: true,
          tips: "如果您需要更改您的邮箱，请输入新的邮箱并确认",
          input: [
            {
              label: "当前邮箱",
              id: "current_email",
              value: "",
              readonly: true,
              see: true
            },
            {
              label: "新邮箱",
              id: "new_email",
              value: "",
              see: true
            },
            {
              label: "确认邮箱",
              id: "sure_email",
              value: "",
              see: true
            }
          ]
        },
        {
          title: "密码管理",
          readonly: true,
          tips: "如果您需要更改密码，请输入当前密码并设置新的密码",
          input: [
            {
              label: "当前密码",
              id: "current_pwd",
              value: "",
              see: false
            },
            {
              label: "新密码",
              id: "new_passpord",
              value: "",
              see: false
            },
            {
              label: "确认密码",
              id: "sure_password",
              value: "",
              see: false
            }
          ]
        }
      ]
    };
  },
  methods: {
    //控制编辑
    isEdit(index) {
      let self = this;
      for (let i = 0; i < self.list.length; i++) {
        if (i === index) {
          self.list[i].readonly = !self.list[i].readonly;
        } else {
          self.list[i].readonly = true;
        }
      }
    },
    saveData() {
      let self = this;
      //判断是否为空
      if (
        !self.list[0].input[0].value.trim() ||
        !self.list[0].input[1].value.trim() ||
        !self.list[0].input[2].value.trim()
      ) {
        self.$notify.info({
          message: "联系人信息不允许为空",
          offset: 70
        });
        return false;
      }
      // let emailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      let emailReg = /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      //判断两个邮箱是否一致
      if (
        self.list[1].input[1].value.trim() !==
        self.list[1].input[2].value.trim()
      ) {
        self.$notify.info({
          message: "两次输入邮箱不一致",
          offset: 70
        });
        return false;
      }
      if (
        (self.list[1].input[1].value || self.list[1].input[2].value) &&
        (!emailReg.test(self.list[1].input[1].value) ||
          !emailReg.test(self.list[1].input[2].value))
      ) {
        //邮箱是否符合规范
        self.$notify.info({
          message: "邮箱格式不正确",
          offset: 70
        });
        return false;
      }
      //先判断是否输入了当前密码，再判断两次密码是否一致
      if (
        self.list[2].input[0].value.trim() !== "" &&
        self.list[2].input[1].value !== self.list[2].input[2].value
      ) {
        self.$notify.info({
          message: "两次密码输入不一致",
          offset: 70
        });
        return false;
      }
      //如果当前密码不为空，而新密码为空
      if (
        self.list[2].input[0].value.trim() &&
        (!self.list[2].input[1].value || !self.list[2].input[2].value)
      ) {
        self.$notify.info({
          message: "请输入新密码和确认密码",
          offset: 70
        });
        return false;
      }
      //密码正则匹配，必须包含大小写字母和数字，可以有特殊字符，不允许有空格
      let pwdReg = /^(?=[\S]{8,32}$)(?=[\S]*[A-Z])(?=[\S]*[a-z])(?=[\S]*[0-9])[\S]*/;
      if (
        self.list[2].input[1].value &&
        !pwdReg.test(self.list[2].input[1].value)
      ) {
        self.$notify.info({
          title: "新密码格式错误",
          message: "必须同时有大小写字母和数字，不能有空格",
          offset: 70
        });
        return false;
      }
      //执行到这儿，便可以走发送邮件流程
      let email = self.list[1].input[1].value
        ? self.list[1].input[1].value
        : "";
      let contact =
        self.list[0].input[0].value == self.oldData.contact
          ? ""
          : self.list[0].input[0].value;
      let phone =
        self.list[0].input[1].value == self.oldData.phone
          ? ""
          : self.list[0].input[1].value;
      let address =
        self.list[0].input[2].value == self.oldData.address
          ? ""
          : self.list[0].input[2].value;
      let oldPwd = self.list[2].input[0].value
        ? self.list[2].input[0].value
        : "";
      let newPwd = oldPwd ? self.list[2].input[1].value : "";
      if (!email && !contact && !phone && !address && !oldPwd && !newPwd) {
        self.$notify.info({
          message: "未做任何修改！",
          offset: 70
        });
        return false;
      }

      const user = JSON.parse(sessionStorage.getItem("user"));

      const postChange = () => {
        self.loading = true;
        post("user/pcibuserinfo/change/", {
          new_email: email,
          new_password: newPwd,
          phone: phone,
          contact: contact,
          old_password: oldPwd,
          address: address,
          crm_order_no: user.crm_order_no
        }).then(
          res => {
            self.loading = false;
            self.$notify({
              type: "success",
              title: "邮件发送成功",
              message: "请前往邮箱确认修改以便生效",
              offset: 70
            });
          },
          err => {
            self.loading = false;
            if (err.status === 500) {
              self.$notify({
                type: "error",
                message: "服务器错误",
                offset: 70
              });
            } else {
              for (let x in err.data) {
                self.$notify({
                  type: "error",
                  message: err.data[x][0],
                  offset: 70
                });
              }
            }
          }
        );
      };

      const h = this.$createElement;
      if (
        this.list[0].input[0].value.trim() !== this.oldData.contact ||
        (this.list[1].input[1].value.trim() &&
          this.list[1].input[0].value !== this.list[1].input[1].value.trim())
      ) {
        this.$confirm(
          h("p", null, [
            h(
              "div",
              null,
              "1.  请注意在您名下至少保留一个订单，您才能登录本系统。    如果您把您的所有订单联系人都修改为其他人，您将不能用当前订单号+密码登陆本系统。"
            ),
            h(
              "div",
              null,
              "2. 我们将发送一封验证邮件至您邮箱，请您于三天内完成验证，验证成功10分钟后重新登录即可查看相关修改信息"
            )
          ]),
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            customClass: "send-alert"
          }
        )
          .then(() => {
            postChange();
          })
          .catch(() => {
            self.loading = false;
          });
      } else {
        postChange();
      }
    }
  },
  computed: {
    isDisabled: function() {
      let self = this;
      let flag = false;
      if (
        self.list[0].input[0].value === self.oldData.contact ||
        self.list[0].input[1].value === self.oldData.phone ||
        self.list[0].input[2].value === self.oldData.address ||
        (self.list[1].input[2].value.trim() === "" ||
          self.list[1].input[2].value.trim() === "") ||
        self.list[2].input[0].value.trim() === ""
      ) {
      }
    }
  }
};
</script>

<style lang="scss">
.el-message-box.send-alert {
  width: 580px;

  .el-message-box__status + .el-message-box__message {
    color: #990000;
  }

  .el-message-box__status {
    top: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibOrderAccount.vue